import { Typography } from '@pwskills/rachnaui';
import React from 'react';
import { ICategoryCardDetails } from '../../../interfaces/homePage';

const KeyBenefitsCard = (category: ICategoryCardDetails) => {
  return (
    <div
      //   key={item?.id}
      className="flex flex-col w-full medium:!w-[48%] large:!w-[23%] large:!min-w-[302px] !justify-start gap-x-4 large:!self-start bg-[#FFFFFF] !px-5 !py-4 !m-0 gap-2 !h-[156px] border !border-stroke-200 rounded"
    >
      <div className="flex flex-col justify-center gap-2 !h-full">
        <div>
          {category?.icon && (
            <div className="flex items-start">
              <img src={`${category?.icon}`} alt="no-course-found" width={40} height={40} />
            </div>
          )}
        </div>
        <div className="w-full">
          <Typography
            component="body-regular"
            variant="bold"
            className="text-gray-850 !text-[16px] !text-left !line-clamp-1"
          >
            {category?.title}
          </Typography>
        </div>
        <div className="w-full">
          <Typography
            component="body-regular"
            variant="regular"
            className="text-gray-650 !text-[14px] !line-clamp-2 !text-left medium:!leading-[22px] !h-11"
          >
            {category?.subText}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default KeyBenefitsCard;
